import { OTPInput, OTPInputContext } from 'input-otp';
import { Dot } from 'lucide-react';
import * as React from 'react';

import { cn } from '@/utils/index';

const InputOTP = ({
  className,
  containerClassName,
  isError,
  ...props
}: React.ComponentPropsWithRef<typeof OTPInput> & {
  isError?: boolean;
}) => {
  return (
    <OTPInput
      containerClassName={cn('flex items-center gap-2 relative group has-disabled:opacity-60', containerClassName, isError && 'otp-input-error')}
      className={cn('disabled:cursor-not-allowed', className)}
      aria-invalid={isError}
      {...props}
    />
  );
};

const InputOTPGroup = ({ className, ...props }: React.ComponentPropsWithRef<'div'>) => {
  const inputOTPContext = React.use(OTPInputContext);
  const { isFocused } = inputOTPContext;
  return (
    <div
      className={cn(
        'input-otp-group',
        'flex items-center',
        !isFocused && 'group-[.otp-input-error]:border-outline-error group-[.otp-input-error]:rounded-input group-[.otp-input-error]:border-2',
        className,
      )}
      {...props}
    />
  );
};

const InputOTPSlot = ({ index, className, ...props }: React.ComponentPropsWithRef<'div'> & { index: number }) => {
  const inputOTPContext = React.use(OTPInputContext);
  const { isFocused } = inputOTPContext;
  const { char, hasFakeCaret, isActive } = inputOTPContext.slots[index];

  return (
    <div
      className={cn(
        'input-otp-slot',
        'first:rounded-l-input last:rounded-r-input text-body-m-regular relative flex h-10 w-10 items-center justify-center border-y border-r first:border-l',
        isActive && 'shadow-focus outline-outline-focus z-10 border-0 outline-2',
        !isFocused &&
          'group-[.otp-input-error]:h-[36px] group-[.otp-input-error]:border-y-0 group-[.otp-input-error]:first:w-[38px] group-[.otp-input-error]:first:border-l-0 group-[.otp-input-error]:first:pr-[1px] group-[.otp-input-error]:last:w-[38px] group-[.otp-input-error]:last:border-r-0 group-[.otp-input-error]:last:pl-[1px]',
        className,
      )}
      {...props}
    >
      {char}
      {hasFakeCaret && (
        <div className='pointer-events-none absolute inset-0 flex items-center justify-center'>
          <div className='animate-caret-blink bg-fill-background-neutral h-4 w-px duration-1000' />
        </div>
      )}
    </div>
  );
};

const InputOTPSeparator = ({ ...props }: React.ComponentPropsWithRef<'div'>) => (
  <div role='separator' {...props}>
    <Dot />
  </div>
);

export { InputOTP, InputOTPGroup, InputOTPSeparator, InputOTPSlot };
